import React, { useEffect, useState } from 'react'
import TextField from '@mui/material/TextField'
import Axios from 'axios'
import { useNavigate } from 'react-router-dom'
import { jwtDecode } from 'jwt-decode'

import { showError, showSuccess } from '../helperfunction/sweetalert.js'
import { useAuth } from '../context/usercontext'

import Logo from '../assets/img/logoFull.png'
import server from '../variables'

const Login = () => {
  const navigate = useNavigate()
  const { setUser } = useAuth()

  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    document.title = 'Rean Billing System'
  }, [])

  const loginUser = async (e) => {
    e.preventDefault()

    if (!email || !password) {
      return showError('Please fill all the fields!')
    }

    try {
      setIsLoading(true)

      const { data } = await Axios.post(`${server}auth/login`, {
        email,
        password,
      })

      if (data.status !== 200) {
        return showError(data.message || 'Invalid Credentials')
      }

      localStorage.setItem('token', data.token)

      const decoded = jwtDecode(data.token)

      setUser({
        email: decoded.email,
        name: decoded.name,
        role: decoded.role,
      })

      await showSuccess('Login Successful! Redirecting...')

      const roleRoutes = {
        admin: '/admin/dashboard',
        field: '/dashboard/consumers',
        manager: '/dashboard',
        monitoring: '/dashboard/consumers',
      }

      navigate(roleRoutes[decoded.role] || '/')
    } catch (err) {
      console.error(err)
      showError('Internal Server Error!')
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <div className='login'>
      <div className='login-card'>
        <div className='col-md-1 col-5 logo'>
          <img className='logo img-fluid' src={Logo} alt='logo' />
        </div>

        {/* Form */}
        <form className='form col-md-3 col-12' onSubmit={loginUser}>
          <div className='mb-3'>
            <TextField
              label='Email'
              variant='outlined'
              className='input col-12'
              type='email'
              size='small'
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              disabled={isLoading}
              required
            />
          </div>

          <div className='mb-3'>
            <TextField
              label='Password'
              variant='outlined'
              className='input col-12'
              type='password'
              size='small'
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              disabled={isLoading}
              required
            />
          </div>

          <button
            className='w-100 btn btn-md btn-primary'
            type='submit'
            disabled={isLoading}
          >
            {isLoading ? (
              <span
                className='spinner-border spinner-border-sm me-2'
                role='status'
              />
            ) : (
              'Login'
            )}
          </button>
        </form>
        <div
          className='text-secondary text-center pt-2'
          style={{ fontSize: '0.75rem' }}
        >
          Version: 3.1.1
        </div>
      </div>
    </div>
  )
}

export default Login
